// extracted by mini-css-extract-plugin
export default {"basicInfoWrapper":"BasicInfo_basicInfoWrapper__0RzH-","form":"BasicInfo_form__+FxHJ","fileContainer":"BasicInfo_fileContainer__7hXyb","uploadInfo":"BasicInfo_uploadInfo__ijLAd"};